// Reactive pills for the New + Sale mega menus - client-side render from the embedded
// leaderboard JSON (shop.metafields.mega_menu.*), no fetch needed. Category pills render
// brand-leaderboard cards (mega-brand-card.liquid markup); Sale's Picks/Savings pills render
// individual product cards from board.picks / board.savings. Images load eager (no
// loading=lazy) since this panel is hidden until hover - lazy caused a late image pop-in.
(function () {
	var boardCache = {};

	function getBoard(boardId) {
		if (boardCache[boardId]) return boardCache[boardId];
		var el = document.querySelector('[data-mega-board="' + boardId + '"]');
		if (!el) return null;
		try {
			boardCache[boardId] = JSON.parse(el.textContent);
		} catch (e) {
			return null;
		}
		return boardCache[boardId];
	}

	function esc(s) {
		var d = document.createElement('div');
		d.innerText = s == null ? '' : s;
		return d.innerHTML;
	}

	function brandCardHtml(b, eyebrow, verb) {
		var logoImg = b.logo ? '<img class="megacard__logo" src="' + b.logo + '" alt="">' : '';
		return (
			'<a class="megacard megacard--brand" href="' + b.url + '" title="' + esc(b.vendor) + '">' +
				'<div class="megacard__img">' +
					(b.image ? '<img src="' + b.image + '" alt="' + esc(b.vendor) + '">' : '') +
					logoImg +
				'</div>' +
				'<div class="megacard__meta">' +
					'<div class="megacard__eyebrow">' + esc(eyebrow) + '</div>' +
					'<div class="megacard__brand">' + esc(b.vendor) + '</div>' +
					'<div class="megacard__copy">' + b.count + ' products ' + esc(verb) + ', including ' + esc(b.title) + '.</div>' +
				'</div>' +
			'</a>'
		);
	}

	function productCardHtml(p) {
		var seal = p.save ? '<span class="megacard__seal megacard__seal--sale"><span class="megacard__seal-l">Save</span><span class="megacard__seal-a">$' + p.save + '</span></span>' : '';
		return (
			'<a class="megacard" href="' + p.url + '" title="' + esc(p.title) + '">' +
				'<div class="megacard__img">' +
					seal +
					(p.image ? '<img src="' + p.image + '" alt="' + esc(p.title) + '">' : '') +
				'</div>' +
				'<div class="megacard__meta">' +
					'<div class="megacard__vendor">' + esc(p.vendor) + '</div>' +
					'<div class="megacard__name">' + esc(p.title) + '</div>' +
					'<div class="megacard__price">$' + p.price + '</div>' +
				'</div>' +
			'</a>'
		);
	}

	function renderCat(root, boardId, key) {
		var board = getBoard(boardId);
		if (!board) return;
		var grid = root.querySelector('[data-mega-cards]');
		if (!grid) return;
		var eyebrow = boardId === 'new' ? 'Just landed' : 'On sale';
		var verb = boardId === 'new' ? 'landed this week' : 'on sale';

		if (key === 'picks' || key === 'savings') {
			var products = board[key] || [];
			grid.innerHTML = products.map(productCardHtml).join('');
			return;
		}
		var cat = (board.categories || []).find(function (c) { return c.key === key; });
		if (!cat) return;
		grid.innerHTML = cat.brands.map(function (b) { return brandCardHtml(b, eyebrow, verb); }).join('');
	}

	function init(root) {
		if (root.__ckMegaInit) return; root.__ckMegaInit = true; /* CK 22 Sep 26 perf: idempotent so the drawer clone can re-run it */
		var boardId = root.classList.contains('newmega') ? 'new' : 'sale';
		var pills = root.querySelectorAll('[data-mega-cat]');
		pills.forEach(function (pill) {
			pill.addEventListener('click', function () {
				pills.forEach(function (p) { p.classList.remove('active'); });
				pill.classList.add('active');
				renderCat(root, boardId, pill.getAttribute('data-mega-cat'));
			});
		});
	}

	document.querySelectorAll('.newmega, .salemega').forEach(init);
	window.__ckMegaInit = function () { document.querySelectorAll('.newmega, .salemega').forEach(init); };
})();
